<div class="uploaded-file">
  <app-row align="center" class="no-gutters">
    <app-col>
      <app-icon class="uploaded-file__icon ml-3" name="bold-document"></app-icon>
      <span class="uploaded-file__title">{{title}}</span>
    </app-col>
    <app-col cols="auto">
      <button
        mat-icon-button
        class="text-500 uploaded-file__action"
        (click)="onDownloadClicked()"
        matTooltipPosition="above"
        [matTooltip]="'shared.accordion.Download' | translate"
      >
        <app-icon name="bold-download-square" size="xs"></app-icon>
      </button>
      <button
        *ngIf="hasRemoveButton"
        mat-icon-button
        class="text-500 uploaded-file__delete-action"
        (click)="onRemovedAttachmentClicked()"
        matTooltipPosition="above"
        [matTooltip]="'shared.Buttons.Delete' | translate"
      >
        <app-icon name="bold-close-circle" size="xs"></app-icon>
      </button>
    </app-col>
  </app-row>
</div>
